import React from "react";
import { Users, Music, UtensilsCrossed, PartyPopper, Clock } from "lucide-react";

const UseCases = () => {
  const useCases = [
    {
      icon: Users,
      title: "Sosiale møteplasser",
      description: "Der folk samles og blir lenge – telefonen brukes konstant",
      image: "https://images.unsplash.com/photo-1543007630-9710e4a00a20?w=600&h=400&fit=crop",
    },
    {
      icon: Music,
      title: "Events & konserter",
      description: "Festivaler og arrangementer hvor batteriet dør raskt",
      image: "https://images.unsplash.com/photo-1492684223066-81342ee5ff30?w=600&h=400&fit=crop",
    },
    {
      icon: UtensilsCrossed,
      title: "Serveringssteder",
      description: "Gjester sitter lenge og trenger strøm",
      image: "https://images.pexels.com/photos/1404880/pexels-photo-1404880.jpeg?auto=compress&cs=tinysrgb&w=600&h=400&fit=crop",
    },
    {
      icon: PartyPopper,
      title: "Natteliv",
      description: "Når batteriet dør, stopper kvelden",
      image: "https://images.unsplash.com/photo-1566737236500-c8ac43014a67?w=600&h=400&fit=crop",
    },
    {
      icon: Clock,
      title: "Opphold & venting",
      description: "Steder hvor folk oppholder seg over tid",
      image: "https://images.unsplash.com/photo-1559329007-40df8a9345d8?w=600&h=400&fit=crop",
    },
  ];

  return (
    <section
      id="use-cases"
      className="py-24 md:py-32 bg-[#0A0A0A]"
      data-testid="use-cases-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
        {/* Section Header */}
        <div className="text-center mb-16 md:mb-20">
          <span className="text-xs tracking-[0.2em] uppercase font-bold text-[#FFD84D] mb-4 block">
            Bruksområder
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-white font-['Outfit']">
            Perfekt for
          </h2>
        </div>

        {/* Use Cases Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {useCases.map((useCase, index) => (
            <div
              key={index}
              className={`relative overflow-hidden rounded-2xl group cursor-pointer ${
                index === 0 ? "lg:col-span-2 lg:row-span-2" : ""
              }`}
              data-testid={`use-case-${index + 1}`}
            >
              {/* Background Image */}
              <div className="absolute inset-0">
                <img
                  src={useCase.image}
                  alt={useCase.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-[#0A0A0A]/60 to-transparent" />
              </div>

              {/* Content */}
              <div className={`relative z-10 p-8 flex flex-col justify-end ${
                index === 0 ? "min-h-[400px] lg:min-h-[500px]" : "min-h-[280px]"
              }`}>
                {/* Icon */}
                <div className="icon-wrapper mb-4 group-hover:shadow-[0_0_20px_rgba(255,216,77,0.3)] transition-all">
                  <useCase.icon className="w-6 h-6 text-[#FFD84D]" />
                </div>

                {/* Text */}
                <h3 className={`font-semibold text-white mb-2 font-['Outfit'] ${
                  index === 0 ? "text-2xl md:text-3xl" : "text-xl"
                }`}>
                  {useCase.title}
                </h3>
                <p className="text-[#A1A1AA] leading-relaxed">
                  {useCase.description}
                </p>
              </div>

              {/* Hover border effect */}
              <div className="absolute inset-0 border-2 border-transparent group-hover:border-[#FFD84D]/30 rounded-2xl transition-colors duration-300" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UseCases;
